<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="loaded ? dispute.header_text : ''">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <ng-container *ngIf="loaded">

      <tidy-card>
        <tidy-row class="field-bottom-padding">
          <tidy-text
          [body]="'You can counter the initial proposal with a message and lower % back for the client if you\'d like.'">
          </tidy-text>
        </tidy-row>
        <form [formGroup]="form">
          <tidy-row class="field-bottom-padding">
            <tidy-textarea
              [label]="'What Happened?'"
              formControlName="message"
              [form]="form.controls.message"
              [submitted]="submitted"
              [icon]="'assets/svg/information-circle-outline.svg'"
              [errorMessage]="'Please enter a message'">
            </tidy-textarea>
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'What % of the job cost are you willing to give back?'"
              [icon]="'assets/svg/cash-outline.svg'"
              formControlName="percentage"
              [form]="form.controls.percentage"
              [submitted]="submitted"
              [customMask]="percentageMask"
              [inputMode]="'numeric'"
              [errorMessage]="'Please enter how much you are willing to give back.'">
            </tidy-input>
          </tidy-row>
        </form>
      </tidy-card>

      <tidy-error-message
        *ngIf="errorMessage"
        [text]="errorMessage">
      </tidy-error-message>

      <tidy-button
        [text]="'Send Counter Proposal'"
        [action]="counterDisputeProposal.bind(this)"
        class="primary">
      </tidy-button>

    </ng-container>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
